var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-7"},[_c('app-fiche'),_vm._v(" "),_c('app-contact')],1),_vm._v(" "),_c('div',{staticClass:"column is-5"},[_c('app-carte'),_vm._v(" "),_c('app-historique')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1918b8d9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clientProspect/ficheClient/information/index.vue
// module id = null
// module chunks = 